import { useEffect, useRef, useState } from 'react';

export function useDelayedVisibilityOnFocus(delay: number = 1000) {
  const [isVisible, setIsVisible] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const hasBeenShownRef = useRef(false);

  const startTimer = () => {
    clearTimer();
    timerRef.current = setTimeout(() => {
      setIsVisible(true);
      hasBeenShownRef.current = true;
    }, delay);
  };

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const shouldStartTimer = () => {
    const isTabActive = document.visibilityState === 'visible';
    const isWindowFocused = document.hasFocus();

    return isTabActive && isWindowFocused;
  };

  useEffect(() => {
    const handleVisibilityOrFocus = () => {
      if (hasBeenShownRef.current) return;

      if (shouldStartTimer()) {
        startTimer();
      } else {
        clearTimer();
        setIsVisible(false);
      }
    };

    if (shouldStartTimer()) {
      startTimer();
    }

    document.addEventListener('visibilitychange', handleVisibilityOrFocus);
    window.addEventListener('focus', handleVisibilityOrFocus);
    window.addEventListener('blur', handleVisibilityOrFocus);

    return () => {
      clearTimer();
      document.removeEventListener('visibilitychange', handleVisibilityOrFocus);
      window.removeEventListener('focus', handleVisibilityOrFocus);
      window.removeEventListener('blur', handleVisibilityOrFocus);
    };
  }, [delay]);

  return isVisible;
}
